import { render, staticRenderFns } from "./CategoryFilter.vue?vue&type=template&id=338fd586&scoped=true"
import script from "./CategoryFilter.vue?vue&type=script&lang=js"
export * from "./CategoryFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "338fd586",
  null
  
)

export default component.exports